import { colours } from "@/utils";
import { Device } from "@/utils/device";
import * as Router from "next/router";
import { FunctionComponent } from "react";
import styled from "styled-components";

type StyleProps = {
  isActive?: boolean;
  activeColour?: string;
  inactiveColour?: string;
  reduceTextSize?: boolean;
};

type MarketingSubNavProps = {
  activeSection: string;
  navHandler: (string) => void;
  pageBase: string;
  activeColour?: string;
  inactiveColour?: string;
  navItems: {
    href: string;
    text: string;
  }[];
};

const MarketingSubNav: FunctionComponent<MarketingSubNavProps> = (props) => {
  const router = Router.useRouter();

  const handleChange = (slug) => {
    props.navHandler(slug);
    router.push(`/${props.pageBase}/${slug}`, undefined, { shallow: true });
  };

  return (
    <S.SubNavContainer>
      {props.navItems.map((item) => (
        <S.NavItem
          key={item.href}
          isActive={props.activeSection === item.href}
          name={item.text}
          reduceTextSize={item.text.length > 30}
          onClick={() => handleChange(item.href)}
          {...props}
        >
          {item.text}
        </S.NavItem>
      ))}
    </S.SubNavContainer>
  );
};

const S = () => {};

S.SubNavContainer = styled.nav`
  width: 100%;
  height: 80px;
  display: flex;
`;

S.NavItem = styled.button<StyleProps>`
  width: 100%;
  background: ${(p) =>
    p.isActive
      ? p.activeColour || colours.shellOverlay
      : p.inactiveColour || colours.shell};
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  font-size: ${(p) => (p.reduceTextSize ? "12px" : "inherit")};
  cursor: pointer;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-line;

  &:hover {
    filter: brightness(0.95);
  }

  @media (min-width: ${Device.tablet}) {
    font-size: inherit;
  }
`;

export default MarketingSubNav;
